import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  margin-top: 33px;
  margin-bottom: 33px;
  padding: 0 16px;
  @media (max-width: ${breakpoints.mobileM}) {
    padding: 0 8px;
  }
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 0 8px;
  }
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled(TableHeaderRow)`
  border-top: none;
  height: 40px;
  ${({ index }) => (index % 2 === 0 ? "background-color: #FAFAFF;" : "")}
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;

function TableRow({ index, ...props }) {
  return (
    <TableBodyRow index={index}>
      <TableBodyCellLeft>{props.internationalCode.join(", ")}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.usCode.join(", ")}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.statusCode}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.statusDate}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.firstUseAnywhereDate}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.firstUseInCommerceDate}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.primaryCode}</TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  internationalCode: PropTypes.arrayOf(PropTypes.string),
  usCode: PropTypes.arrayOf(PropTypes.string),
  statusCode: PropTypes.string,
  statusDate: PropTypes.string,
  firstUseAnywhereDate: PropTypes.string,
  firstUseInCommerceDate: PropTypes.string,
  primaryCode: PropTypes.string,
};

function ClassificationList({ classifications }) {
  if (!classifications) return null;

  return (
    <Container>
      <Title>Classification</Title>
      <Table responsive>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCellLeft>INTERNETIONAL CODE</TableHeaderCellLeft>
            <TableHeaderCellLeft>US CODE</TableHeaderCellLeft>
            <TableHeaderCellLeft>STATUS CODE</TableHeaderCellLeft>
            <TableHeaderCellLeft>STATUS DATE</TableHeaderCellLeft>
            <TableHeaderCellLeft>FIRST USE ANYWHERE DATE</TableHeaderCellLeft>
            <TableHeaderCellLeft>FIRST USE IN COMMERCE DATE</TableHeaderCellLeft>
            <TableHeaderCellLeft>PRIMARY CODE</TableHeaderCellLeft>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {classifications.map((classificationInfo, idx) => (
            <TableRow key={idx} index={idx} {...classificationInfo} />
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}

ClassificationList.propTypes = {
  classifications: PropTypes.arrayOf(PropTypes.object),
};

export default ClassificationList;
